import { QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'

import type { AuthContextValue } from '@/lib/auth/context'
import { RootErrorBoundary } from '@/components/shell/RootErrorBoundary'
import { NotFound } from '@/components/shell/NotFound'

export interface RouterContext {
  auth: AuthContextValue | null
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  errorComponent: RootErrorBoundary,
  notFoundComponent: NotFound,
})

function RootComponent() {
  return <Outlet />
}
